import { Typography, Box, FormControlLabel, Checkbox } from '@mui/material';
import { useGetProductionRightsQuery } from 'services/clear/rights';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getBulkRightOptions } from 'redux-core/productions/selectors';
import { setBulkRightsOptions } from 'redux-core/productions/actions';

const RightsOptionsList = ({ productionId }) => {
  const dispatch = useDispatch();
  const bulkRightsOptions = useSelector(getBulkRightOptions);

  const { data } = useGetProductionRightsQuery({ productionId });
  const [selectedRights, setSelectedRights] = useState({});

  const simplifiedData =
    data?.map((item) => ({
      id: String(item.id ?? `unknown_${Math.random()}`),
      name: item.name,
      type: item.type,
    })) || [];

  const handleCheckboxChange = (id) => {
    setSelectedRights((prev) => {
      const updatedRights = {
        ...prev,
        [id]: {
          id,
          used: !prev[id]?.used,
        },
      };
      const updatedRightsOptions = Object.values(updatedRights).map((item) => ({
        id: item.id,
        used: item.used,
      }));
      dispatch(
        setBulkRightsOptions({
          ...bulkRightsOptions,
          rightsOptionsToUpdate: updatedRightsOptions,
        }),
      );
      return updatedRights;
    });
  };

  return (
    <Box
      sx={{
        ml: 1,
        mt: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {simplifiedData.map((item) => (
        <Box
          key={item.id}
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            py: '1px',
            gap: '15px',
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={!!selectedRights[item.id]?.used}
                onChange={() => handleCheckboxChange(item.id)}
                size="small"
                sx={{
                  padding: '0',
                  '& .MuiSvgIcon-root': {
                    width: '24px',
                    height: '24px',
                  },
                }}
              />
            }
            label={
              <Typography
                sx={{
                  color: item.type === 'options' ? 'secondary.main' : 'primary.main',
                  backgroundColor: item.type === 'options' ? 'secondary.300' : 'primary.300',
                  fontSize: '0.688rem',
                  padding: '4px 8px',
                  borderRadius: '0.25rem',
                  textTransform: 'uppercase',
                  fontWeight: '700',
                  display: 'inline-flex',
                  alignItems: 'center',
                  whiteSpace: 'nowrap',
                  ml: 0,
                  lineHeight: '1',
                }}
              >
                {item.name}
              </Typography>
            }
            sx={{
              margin: 0,
              '& .MuiFormControlLabel-label': {
                marginLeft: '15px',
              },
            }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default RightsOptionsList;
